import React, { useState } from "react";
import parser from "html-react-parser";

const Wrapper = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};

const TextareaField = ({
  cols,
  errorMessage = "",
  idField,
  isValid = true,
  label,
  maxLength,
  minLength,
  name,
  onChangeHandler,
  placeholder,
  readOnly,
  required,
  rows,
  value,
  description,
  explanation,
}) => {
  const getInputStyles = (isValid) => {
    return {
      border: isValid ? "1px solid #ccc" : "1px solid #960000",
      background: isValid ? "" : "#f9f0f0",
    };
  };

  const getLabelStyle = (isValid) => {
    return {
      color: isValid ? "" : "#960000",
    };
  };

  return (
    <div className="tps-form-question">
      <>
        {!!label && label !== "" && (
          <label
            style={getLabelStyle(isValid)}
            className={`fatv2-form-label form-control ${
              required
                ? "tps-field-required tps-to-validate"
                : "tps-not-required tps-to-validate"
            }`}
            htmlFor={idField}
          >
            {parser(label)}
          </label>
        )}
        {!!explanation && explanation !== "" && (
          <div className="fas fa-info-circle tps-form-tip has-tip">
            <div
              className="tooltiptext"
              dangerouslySetInnerHTML={{ __html: explanation }}
            ></div>
          </div>
        )}
      </>

      <Wrapper
        wrapper={(children) => <div className="tps-form-input">{children}</div>}
      >
        <textarea
          className="form-textarea"
          style={getInputStyles(isValid)}
          cols={cols}
          id={idField || name}
          name={name}
          onChange={(event) => onChangeHandler(event)}
          placeholder={placeholder}
          required={required}
          rows={rows}
          value={value}
          minLength={minLength}
          maxLength={maxLength}
          readOnly={readOnly}
          suppressHydrationWarning={true}
        />
      </Wrapper>
      {!isValid && (
        <label
          className={`fatv2-body form-control tps-field-required EditingFormErrorLabel`}
          htmlFor={errorMessage}
        >
          {errorMessage}
        </label>
      )}
      {!!description && description !== "" && (
        <p
          className="tps-form-input-explaination"
          dangerouslySetInnerHTML={{ __html: description }}
        ></p>
      )}
    </div>
  );
};

export default TextareaField;
